import * as Sentry from "@sentry/react";
import {Environment} from "./utils/environment";


export const init_sentry = (environment: Environment) => {
    if (environment === 'local') return;

    const dsnConfig = {
        production: "https://3572c0b18d7ae3ca63113de49263bbb3@o4508834184232960.ingest.de.sentry.io/4508846972993616",
        development: "https://61eb08fe628f97eff2ea213a577b696e@o4508834184232960.ingest.de.sentry.io/4508847049146448",
        local: "https://a2270a25b637e158986ad89880120e9f@o4508834184232960.ingest.de.sentry.io/4508846769111120"
    };

    Sentry.init({
        dsn: dsnConfig[environment],
        ignoreErrors: [
            /@firebase\/auth.*INTERNAL ASSERTION FAILED/
        ],
        integrations: [
            Sentry.breadcrumbsIntegration({
                console: false,
                dom: true,
                fetch: true,
                history: true,
                xhr: true,
            }),
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.captureConsoleIntegration({
                levels: ['error']
            })
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/medendo-frontend\.(prod|development)\.medendo\.dev/,
            /^https:\/\/workspace\.medendo\.com/,
            /^https:\/\/workspace\.medendo\.dev/
        ],
        replaysSessionSampleRate: environment === 'development' ? 1.0 : 0,
        replaysOnErrorSampleRate: environment === 'development' ? 1.0 : 0,
        release: process.env.REACT_APP_VERSION,
    });

    setup_console_breadcrumbs();
};

function setup_console_breadcrumbs() {
    const originalWarn = console.warn;
    const originalError = console.error;
    console.warn = (message, ...args) => {
        Sentry.addBreadcrumb({
            category: "console",
            level: "warning",
            message: String(message),
        });
        originalWarn.apply(console, [message, ...args]);
    };

    console.error = (message, ...args) => {
        Sentry.addBreadcrumb({
            category: "console",
            level: "error",
            message: String(message),
        });
        originalError.apply(console, [message, ...args]);
    };
}
